module.exports = __webpack_public_path__ + "static/img/defaultSendIcon.76e5ee4f.svg";